module.exports = __webpack_public_path__ + "b29c00a6e8a65e42c0243ca4a4af9f8b.MP3";